import * as types from './actionType';
import { sendEmailVerificationCode, verifyEmail } from '../apis/formAPIs';

export const setEmailVerifyAction = (data) => ({
  type: types.EMAIL_VERIFY,
  payload: data,
});

export const sendEmailVerificationAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(setEmailVerifyAction('loading'));
      await sendEmailVerificationCode(data);
      dispatch(setEmailVerifyAction('sent'));
      return { ok: true };
    } catch (error) {
      const status = error?.response?.status;
      const retryAfterSeconds = error?.response?.data?.retryAfterSeconds;
      dispatch(setEmailVerifyAction(status === 429 ? 'sent' : 'failed'));
      return { ok: false, status, retryAfterSeconds };
    }
  };
};

export const verifyEmailAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(setEmailVerifyAction('loading'));
      const result = await verifyEmail(data);
      dispatch(setEmailVerifyAction('success'));
    } catch (error) {
      dispatch(setEmailVerifyAction('failed'));
    }
  };
};
